export default __webpack_public_path__ + "static/truck_white_house-ec1ffb7dda7442389bc63d47c0f71916.jpg";